/*
Controller for Candidate Details Page to handle video modal
*/
angular.module('jv.CandDetails.Video', ['App.video.service', 'jv.Common.Directives.jvTinymce'])
    .run(['$rootScope',function($rootScope){
        // tiny mce uses it for its watchers.
        $rootScope.stripNewLines = function(content){
            if(content){
                content = content.replace(/\n/ig, '');
            }
            return content;
        };
    }])
    //VA: Specific service created only for Video Interview invite modal.
    .service('VideoInterviewInviteModalService', ['$rootScope', '$q', '$timeout', '$jobviteUrls', 'appDetailsService',
        function($rootScope, $q, $timeout, $jobviteUrls, appDetailsService) {
            var videoInterviewInviteModalService = {};
            var workflowObject = null;

            /**
             * API to bring up send video interview modal.
             * @param  isContact Whether this call is being made for contacts. True - Contacts, False - Candidates
             * @param  appId Can be applicationId or contactId
             * @param  workflowStateId  Current Workflow ID. Not Required for ad-hoc usecase.
             * @param  workflowStateKind Current Workflow Kind. Not Required for ad-hoc usecase.
             * @param  jobEId    Not Required for ad-hoc usecase. Only for workflow
             * @param  formResponseId Not required for ad-hoc or workflow. ONLY required for grant extension invite modal
             * @return None
             */
            videoInterviewInviteModalService.invite = function(isContact, appId, workflowObject, jobEId, vfrId, deadline) {
                var defer = $q.defer();
                // Get scope for the controller.
                var scope = angular.element("[ng-controller='CandDetailsVideoModalCtrl']").scope();
                //VID-ENGAGE: Move to a service.
                scope.appId = appId;
                scope.isContact = isContact;
                scope.deadline = deadline;
                //VID-ENGAGE: Remove dependancy on rootScope flags. 
                if (angular.isDefined($rootScope.flags)) {
                    $rootScope.flags.loading = true;
                }
                if (angular.isUndefined(scope.lazyLoading.videoTemplatesUrl)) {
                    $rootScope.$broadcast('SET_WORKFLOW_ID', workflowObject, jobEId);

                    if(vfrId!=undefined && vfrId!== null){
                        // if the grant extensin modal is to be popped up.Fill the VFRID
                        $rootScope.$broadcast('SET_VFRID_ID', vfrId);
                    }
                    
                    $timeout(function() {
                        scope.lazyLoading.videoTemplatesUrl = $jobviteUrls.video + "/video/recruiter/sendVideoInterviewInviteModal.html";
                    }, 0);
                } else {
                    // check if the application is a general application. Do it only if there is a workflowState.
                    var ifGeneralApplication = true;
                    if (angular.isDefined(workflowObject) && angular.isDefined(jobEId)) {
                        ifGeneralApplication = false;
                    }
                    $rootScope.$broadcast('showVideoModal', isContact, appId, workflowObject, ifGeneralApplication, jobEId, vfrId, deadline);
                }
                var derregister = $rootScope.$on('showVideoModalResult', function(event, ifSuccessful) {
                    derregister();
                    defer.resolve(ifSuccessful);
                });
                return defer.promise;
            };

            videoInterviewInviteModalService.inviteContacts = function(contactId) {
                return videoInterviewInviteModalService.invite(true, contactId)
            };

            videoInterviewInviteModalService.inviteCandidates = function(name, applicationId, workflowObject, jobEId) {
                appDetailsService.setApplicantName(name);
                return videoInterviewInviteModalService.invite(false, applicationId, workflowObject, jobEId);
            }

            videoInterviewInviteModalService.grantExtension = function(fullName, applicationId, vfrId, deadline) {
                appDetailsService.setApplicantName(fullName);
                return videoInterviewInviteModalService.invite(false, applicationId, null, null, vfrId, deadline);
            }


            return videoInterviewInviteModalService;
        }
    ])
// Parent controller for all the Video related modals.
.controller('CandDetailsVideoModalCtrl', ['$scope', 'videoService', '$timeout', '$rootScope', '$jobviteUrls', '$log', 'videoPageService','VideoInterviewInviteModalService',
    function($scope, videoService, $timeout, $rootScope, $jobviteUrls, $log, videoPageService, VideoInterviewInviteModalService) {
        //VA: This is the only controller that will get called from both the contacts and candidate details. We can put the permisstions
        // logic here for video.
        $scope.deadline = null;
        if (videoPageService.getPageType() === 'CANDIDATE_DETAIL') {
            $rootScope.$on('REQUEST_VIDEO_VIEW', function(event, params){
                // get video permissions.
                videoService.getVideoPermissions(params.applicationId, function(data) {
                    if (angular.isDefined(data.videoViews)) {
                        var videoViews = eval('({' + data.videoViews + '})');
                        angular.extend(params.views, videoViews);
                    }
                });

                //get completed videos count.
                videoService.getCompleteVideoInterviewCount(params.applicationId, function(data){
                    // do something to change the count on the video video tab.
                    $rootScope.totalVideoCompletedQuestionnaireCount = data.completedVideoCount;
                    $scope.$emit('updateVideoCount',$rootScope.totalVideoCompletedQuestionnaireCount);
                });
            });
        }


        $scope.lazyLoading = $scope.lazyLoading || {};
        $scope.modal = {
            preview: false,
            sendVideo: false,
            inviteReviewerModal: false,
            sendReminder: false,
            evalReqMoreInfo: false,
            evalSendReminder: false,
            errorQuestionnaireModal: false
        };
        //TODO-Pranav: Stuff to be removed and moved to its own controller
        $scope.hidePreview = function() {
            $scope.modal.preview = false;
            $scope.modal.sendVideo = true;
        };

        $scope.hideModals = function() {
            $scope.$broadcast('hidingVideoModals');
            $scope.modal.preview = false;
            $scope.modal.sendVideo = false;
            $scope.modal.inviteReviewerModal = false;
            $scope.modal.sendReminder = false;
            $scope.modal.evalReqMoreInfo = false;
            $scope.modal.evalSendReminder = false;
            $scope.submitted = false;
            $scope.modal.hideBackToSendVideo = false;
            $scope.modal.errorQuestionnaireModal = false;
            $scope.grantExtensionModal = false;
        };

        var reviwerObj = {};
        $scope.$on('SHOW_VIDEO_INVITE_MODAL', function(event, id, appid) {
            reviwerObj.id = id;
            reviwerObj.appid = appid;
            if ($scope.lazyLoading.videoTemplatesInviteReviewerUrl === undefined) {
                $scope.lazyLoading.videoTemplatesInviteReviewerUrl = $jobviteUrls.video + "/video/recruiter/inviteReviewersModal.html";
            } else {
                $scope.inviteReviewerModalLoaded();
            }
        });

        $scope.$on('SHOW_VIDEO_INVITE_GRANT_EXTENSION_MODAL', function(event, fullName, applicationId, vfrId, deadline) {
            //VA: will use the send video interview invite modal.
            var promise = VideoInterviewInviteModalService.grantExtension(fullName, applicationId, vfrId,deadline)
            promise.then(function(result){
                if(result===true){
                    $rootScope.$broadcast('REFRESH_VIDEO_LIST');
                }
            })
        });


        $scope.$on('SHOW_VIDEO_QUESTIONNAIRE_ERROR_MODAL', function(event, emailObject) {
            // If only one application and the error is that email is not present show this error.
            $scope.emailError = false;
            if(angular.isDefined(emailObject) && angular.isDefined(emailObject.emailUnknown)){
                $scope.emailError = true;
            }
            if ($scope.lazyLoading.videoErrorTemplateUrl === undefined) {
                $scope.lazyLoading.videoErrorTemplateUrl = $jobviteUrls.video + "/video/recruiter/videoQuestionnaireError.html";
            } else {
                $scope.showQuestionnaireErrorModal();
            }
        });

        $scope.$on('SHOW_VIDEO_QUESTIONNAIRE_ERROR_MODAL_FROM_CANDIDATE_LIST', function(event, totalSelected) {
            $scope.totalSelected = totalSelected;
            $scope.triggeredFromCandidateList = true;
            $scope.showQuestionnaireErrorModal();
        });

        $scope.showQuestionnaireErrorModal = function() {
            $timeout(function() {
                $scope.modal.errorQuestionnaireModal = true;
            }, 0);
        };

        $scope.inviteReviewerModalLoaded = function() {
            $timeout(function() {
                $rootScope.$broadcast('SHOW_VIDEO_INVITE', reviwerObj.id, reviwerObj.appid);
                $scope.modal.inviteReviewerModal = true;
            }, 0);
        };

        var workflowObject = null, vfrId = null;
        var jobEId;

        $scope.$on('SET_WORKFLOW_ID', function(event, workflowObjectParam, jobEIdParam) {
            //VID-ENGAGE: Ideally this check should be happening at the caller. Being Safe!
            if (angular.isDefined(workflowObjectParam)) {
                workflowObject = workflowObjectParam;
            }
            jobEId = jobEIdParam;
        });
        $scope.$on('SET_VFRID_ID', function(event, VFRID){
            vfrId = VFRID;
            // VA: Used for changing the header title of the modal between send video interview invite and grant extension modal.
            $scope.grantExtensionModal = true;
        });

        $scope.videoTemplateUrlLoaded = function() {
            $timeout(function() {
                // check if the application is a general application. Do it only if there is a workflowState.
                var ifGeneralApplication = true;
                if (angular.isDefined(workflowObject) && angular.isDefined(jobEId)) {
                    ifGeneralApplication = false;
                }
                $rootScope.$broadcast('showVideoModal', $scope.isContact, $scope.appId, workflowObject, ifGeneralApplication, jobEId, vfrId, $scope.deadline);
            }, 0);
        };

        $scope.videoSendReminderTemplateUrlLoaded = function() {
            $timeout(function() {
                $rootScope.$broadcast('sendReminderModalCtrl', $scope.SId);
            }, 0);
        };

        $scope.videoEvalRequestMoreInformationUrlLoaded = function() {
            $timeout(function() {
                $rootScope.$broadcast('evalRequestMoreInformationCtrl', $scope.evalItem);
            }, 0);
        };

        $scope.videoEvalSendReminderUrlLoaded = function() {
            $timeout(function() {
                $rootScope.$broadcast('evalSendReminderCtrl', $scope.evalPending, $scope.formId);
            }, 0);
        };

        $scope.videoPreviewTemplateUrlLoaded = function() {
            $timeout(function() {
                openPreviewQuestionnaire();
            });
        };

        $scope.$on('sendReminderModalClick', function(event, args) {
            $scope.SId = args;
            $scope.lazyLoading.videoSendReminderTemplateUrl = $jobviteUrls.video + "/video/recruiter/sendReminderModal.html";
            $rootScope.$broadcast('sendReminderModalCtrl', $scope.SId);
        });

        $scope.$on('evalRequestMoreInformation', function(event, args) {
            $scope.evalItem = args;
            $scope.lazyLoading.videoEvalRequestMoreInformationUrl = $jobviteUrls.video + "/video/recruiter/evalRequestMoreInformation.html";
            $rootScope.$broadcast('evalRequestMoreInformationCtrl', $scope.evalItem);
        });

        $scope.$on('evalSendReminder', function(event, args, interviewID) {
            $scope.evalPending = args;
            $scope.formId = interviewID;
            $scope.lazyLoading.videoEvalSendReminderUrl = $jobviteUrls.video + "/video/recruiter/evalSendReminder.html";
            $rootScope.$broadcast('evalSendReminderCtrl', $scope.evalPending, $scope.formId);
        });

        var openPreviewQuestionnaire = function(e, val) {
            $scope.modal.sendVideo = false;
            if (angular.isDefined($scope.flags)) {
                $scope.flags.loading = true;
            }
            var videoForm = {};
            videoForm.questionID = $scope.modal.questionnaireId;
            $timeout(function() {
                videoService.previewQuestionnaire(videoForm, function(data, status) {
                    if (status === 200) {
                        if (angular.isDefined($scope.flags)) {
                            $scope.flags.loading = false;
                        }
                        $scope.modal.preview = true;
                        $scope.quesDetail = data.bean;
                        $scope.totalTime = data.time;
                    }
                });
            }, 400);
        };

        $scope.$on('previewQuestionnaire', function(e, val) {
            $scope.modal.questionnaireId = val;
            openPreviewQuestionnaire();
        });

        $scope.$on('previewOnlyQuestionnaire', function(e, val) {
            $scope.modal.hideBackToSendVideo = true;
            $scope.lazyLoading.videoPreviewTemplateUrl = $jobviteUrls.video + "/video/recruiter/previewVideoInterviewModal.html";
            $scope.modal.questionnaireId = val;
        });
    }
]);